<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card position-relative">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo mb-0">Relatório Rota Inteligente</h1>
        <p class="paragrafo mb-4"></p>

        <!-- TIPO RELATORIO -->
        <form [formGroup]="formulario" classs="m-0">
          <div class="row g-0 mb-4 faixa-relatorio">
            <div class="col-12 ms-4">
              <div class="content">
                <!-- RADIO -->
                <div col="col-6">
                  <span class="label-menor mt-4">TIPO DE RELATÓRIO</span> <br>
                  <div class="form-check form-check-inline justify-content-center align-self-center">
                    <input type="radio" formControlName="tipoRelatorio" id="usuarioRoteirizacao" class="form-check-input" value="2">
                    <label class="form-check-label" for="usuarioRoteirizacao">Usuários roteirizados</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input type="radio" formControlName="tipoRelatorio" id="cobrancaRoteirizacao" class="form-check-input" value="1">
                    <label class="form-check-label" for="cobrancaRoteirizacao">Cobrança roteirização</label>
                  </div>
                </div>
                <!-- DATAS -->
                <div class="col-6 mt-3">
                  <div class="content">
                    <div class="col-6">
                      <div class="mb-4">
                        <label class="label-menor" for="dataInicial">Data Inicial</label>
                        <input class="form-control d-inline m-0" dateMask [matDatepicker]="picker1" id="dataInicial" placeholder="dd/mm/aaaa" formControlName="dataInicial"
                          [(ngModel)]="dataEmissaoInicio" [ngClass]="{ 'is-invalid': dataInicialError }" >
                        <mat-datepicker-toggle matSuffix [for]="picker1" class="datepicker-custom-float"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        @if (dataInicialVazia && dataEmissaoFim != null) {
                          <p class="legenda-erro mt-1 mb-0">Selecione a data inicial</p>
                        }

                        <field-error [isError]="dataInicialError" [message]="dataInicialMessageError"></field-error>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-4">
                        <label class="label-menor" for="dataFinal">Data Final</label>
                        <input class="form-control d-inline m-0" dateMask [matDatepicker]="picker" id="dataFinal" placeholder="dd/mm/aaaa" formControlName="dataFinal"
                          [(ngModel)]="dataEmissaoFim" [ngClass]="{ 'is-invalid': dataFinalError }" >
                        <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker-custom-float"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        @if (dataFinalVazia && dataEmissaoInicio != null) {
                          <p class="legenda-erro mt-1 mb-0">Selecione a data final</p>
                        }
                        <field-error [isError]="dataFinalError" [message]="dataFinalMessageError"></field-error>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- SELECTS USUARIOS -->
          @if (this.formulario.value.tipoRelatorio == 2) {
            <div class="row selects">
              <div class="col-3">
                <label class="label-menor" for="slctSituacaoUsuarios">SITUAÇÃO DOS USUÁRIOS</label>
                <app-select
                  [form]="formulario"
                  name="situacaoUsuario"
                  id="slctSituacaoUsuarios"
                      [options]="[
                      { description : 'Todos' ,
                        value : 'T'} ,
                        { description : 'Ativos' ,
                        value : 'S'} ,
                        { description : 'Inativos' ,
                        value : 'N'}
                      ]"
                  optionValue="value"
                  optionText="description">
                </app-select>
              </div>
              <div class="col-3">
                <label class="label-menor" for="slctSituacaoRoteirizacao">SITUAÇÃO ROTEIRIZAÇÃO</label>
                <app-select
                  [form]="formulario"
                  name="situacaoRoteirizacao"
                  id="slctSituacaoRoteirizacao"
                    [options]="[
                    { description : 'Todos' ,
                      value : 'T'} ,
                      { description : 'Finalizados' ,
                      value : 'F'} ,
                      { description : 'Pendentes' ,
                      value : 'P'}
                    ]"
                  optionValue="value"
                  optionText="description">
                </app-select>
              </div>
              <div class="col-3">
                <label class="label-menor" for="slctDepartamento">DEPARTAMENTO</label>
                <app-select
                  [form]="formulario"
                  name="departamento"
                  id="slctDepartamento"
                  [options]="listaDepartamento"
                  optionValue="idDepartamento"
                  defaultDescription="Usuários de todos departamentos"
                  optionText="descDepartamento">
                </app-select>
              </div>
            </div>
          }

          <!-- BOTAO LISTAR EXCEL -->
          <div class="row justify-content-center mb-2 mt-2">
                <button class="col-5 botao" id="btnListar" [ngClass]="{
                  disabled: !formulario.valid || !('RelatoriosSugestaoDeRota' | usuarioPermissao:'Imprimir' | async)
                }"
              [disabled]="!formulario.valid || !('RelatoriosSugestaoDeRota' | usuarioPermissao:'Imprimir' | async)"
              (click)="avisoData()"
              (click)='dataHoje()'
            (click)='listar()'>LISTAR</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
